import { ClientEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';

import { ClientMainInfoType } from '../types';

export const getClientMainInfoForFinance = (
  client: ClientEntity
): ClientMainInfoType => ({
  email: client.email,
  phone: client.phone,
  country: client.registrationAddress?.country,
  tariff: client.tariff,
  contractNumber: client.serviceContract?.number,
  contractDate: client.serviceContract?.conclusionDate,
  accountNumber: client.personalAccount.number,
  accountOpeningDate: client.personalAccount.openingDate,
  centralDepositoryAccountNumber: client.centralDepositoryAccountNumber,
  centralDepositoryAccountOpeningDate:
    client.centralDepositoryAccountNumberOpeningDate,
  code: client.code,
});

export const getClientMainInfoForGlobal = (
  client: ClientEntity
): ClientMainInfoType => ({
  citizenship: client.citizenships?.[0],
  email: client.email,
  phone: client.phone,
  country: client.residentialAddress?.country,
  tariff: client.tariff,
  contractNumber: client.serviceContract?.number,
  contractDate: client.serviceContract?.conclusionDate,
  accountNumber: client.personalAccount.number,
  accountOpeningDate: client.personalAccount.openingDate,
  centralDepositoryAccountNumber: client.centralDepositoryAccountNumber,
  centralDepositoryAccountOpeningDate:
    client.centralDepositoryAccountNumberOpeningDate,
  code: client.code,
});

export const getClientMainInfo = (
  client: ClientEntity
): ClientMainInfoType | undefined => {
  if (isFinanceProject()) {
    return getClientMainInfoForFinance(client);
  }
  if (isGlobalProject()) {
    return getClientMainInfoForGlobal(client);
  }
  return undefined;
};
